import React, { useState } from "react";
import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  fadeVariants,
  staticBounceVariants,slide_bounce_variants
} from "shared/components/animations";
import arrowLeft from "assets/images/och/left-arrow.png";
import arrowRight from "assets/images/och/right-arrow.png";
import dummyuser from "assets/images/och/dummyuser.png";

import JokeCard from "../components/JokeCard";
import ActiveTag from "assets/images/och/active-tag.png";

const PlayingWaitingScreen = ({
  currentPlayerCard,
  users,
  ActivePlayerInfo,
  currentPlayer,joke
}) => {
  const CardLength = currentPlayerCard?.player_hand.length || null;
  const waitingPlayerList = users?.filter(
    (user) => user?.player_id != currentPlayer?.player_id
  );
  return (
   <>
      <motion.div variants={divVariants}
    initial="hidden"
    animate="visible"
    exit="exit" className="och-playing waiting">
        <motion.h2 variants={fadeVariants}  className="title">Waiting...</motion.h2>
        <div className="och-players-waiting">
          {waitingPlayerList?.map((value, index) => {
            return (
              <motion.div variants={staticBounceVariants} className="wrapper">
                {value?.player_id === ActivePlayerInfo?.player_id && (
                  <img src={ActiveTag} className="pointer" alt="tag" />
                )}
                <div className="player-box">
                 {value?.profile_image ==="profileImage"?<img
                    src={dummyuser}
                    className="img-fluid profile"
                    alt=""
                  /> : <img
                    src={value?.profile_image}
                    className="img-fluid profile"
                    alt=""
                  />}
                  <div className="name-box">
                    <motion.p variants={fadeVariants} className="name"> {value?.display_name}</motion.p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
        <motion.div  variants={staticBounceVariants}className="card-outer">
          {currentPlayerCard?.player_hand?.map((item, index) => (
            <div
              className="cards-inner "
              style={{
                marginTop:
                  index < CardLength / 2
                    ? `-${((index + 1) * CardLength)/2 }px`
                    : `-${(CardLength/2 ) * (CardLength - index)}px`,
                marginLeft: `-${CardLength * 1.5}px`
              }}
            >
              <img src={item?.url} className="img-fluid card-img" alt="" />
            </div>
          ))}
        </motion.div>

        { <JokeCard joke={joke} />}
      </motion.div>
      <div className="arrow-left">
        <img src={arrowLeft} className="img-fluid" alt="" />
      </div>
      <div className="arrow-right">
        <img src={arrowRight} className="img-fluid" alt="" />
      </div>
      </>
  );
};

export default PlayingWaitingScreen;
